import type { DocumentForm } from './document-form'
import { useTranslation } from 'react-i18next'
import { Input } from '~/components/ui/input'
import { Label } from '~/components/ui/label'

type IProps = {
  value: DocumentForm
  onChange: (value: DocumentForm) => void
  sessions: readonly { id: string, name: string }[]
}

/** Les réglages d'un document (#326), communs au dépôt et à la modification. */
function DocumentFields({ value, onChange, sessions }: IProps) {
  const { t } = useTranslation()
  const set = <K extends keyof DocumentForm>(key: K, next: DocumentForm[K]) => onChange({ ...value, [key]: next })

  return (
    <>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="documentTitle" required>{t('documents.column.title')}</Label>
        <Input id="documentTitle" required maxLength={200} value={value.title} onChange={e => set('title', e.target.value)} />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="documentSession">{t('documents.column.session')}</Label>
        <select id="documentSession" value={value.sessionId} onChange={e => set('sessionId', e.target.value)} className="h-10 rounded-md border border-input bg-transparent px-3 text-sm">
          <option value="">{t('documents.allSessions')}</option>
          {sessions.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      </div>
      <div className="flex flex-col gap-1">
        <label className="flex items-center gap-2 text-sm font-medium">
          <input type="checkbox" checked={value.requiredBeforeStart} onChange={e => set('requiredBeforeStart', e.target.checked)} aria-describedby="documentRequiredHelp" />
          {t('documents.required')}
        </label>
        <p id="documentRequiredHelp" className="text-xs text-muted-foreground">{t('documents.requiredHelp')}</p>
      </div>
    </>
  )
}

export default DocumentFields
